module.exports = __webpack_public_path__ + "img/managphone.70aa970f.png";